export class RestoreDynamoDBTableRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "destination",
            "baseName": "destination",
            "type": "DynamodbTableRestoreDestination",
            "format": ""
        },
        {
            "name": "restoreMethod",
            "baseName": "restoreMethod",
            "type": "RestoreMethod",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreDynamoDBTableRequest.attributeTypeMap;
    }
    constructor() {
    }
}
